import { Row, Col, Card, Typography } from "antd";
import { Skeleton, Switch, Avatar, Table, Button, Space } from 'antd';
import Slider from 'react-slick';
import React, { useEffect, useState } from "react";
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
const { Meta } = Card;
const { Text, Link } = Typography;





const PointsTable = () => {
    
    const columns = [
        { title: 'Team', dataIndex: 'teams', key: 'teams' },
        { title: 'P', dataIndex: 'P', key: 'P' },
        { title: 'W', dataIndex: 'W', key: 'W' },
        { title: 'L', dataIndex: 'L', key: 'L' },
        { title: 'NR', dataIndex: 'NR', key: 'NR' },
        { title: 'Pts', dataIndex: 'Pts', key: 'Pts' },
        { title: 'NRR', dataIndex: 'NRR', key: 'NRR' }
      ];
      
      
    
    return(
        <>
        
        {/*       
          <Table
            columns={columns}
            dataSource={data}/> */}

        </>       
        
    );
}

export default PointsTable;